import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { ExpertContext } from "../../data/expert_context_management";
import useExpertRepresentationsApi from "../../data/use_expert_representations_api";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
// The picker (a paginated async expert search + Add button) is plain chrome driven entirely by its
// props, so this page drives the same one the PR engine's own Experts modal uses rather than forking
// it — same reasoning as the employment body reusing the PR editor table.
import AddExpertInput from "../../../pr_profiles/edit/experts_modal_body/add_expert_card/AddExpertInput";

// The Add surface for the represents section. Only the picker lives here: removal happens inline on the
// section itself (every tab), so this body deliberately does not restate the represented list.
//
// Reads the collection + plumbing straight from ExpertContext (the provider owns them — no modal-local
// fetch) and writes via use_expert_representations_api. Same context-based shape as the expert
// EmploymentModalBody.
function ExpertsModalBody({ close }) {
  const context = useContext(ExpertContext);
  const { alsoRepresents, expert, generalError, setActiveTabRequest } = context;
  const { addRepresentation } = useExpertRepresentationsApi(context);

  // Already-represented experts are not pickable again, and neither is the page's own expert: this
  // promoter side self-represents it, and a self-representation is not something the API will create
  // (Id::RepresentationPolicy refuses to touch self_expert rows at all).
  const excludedExpertIds = [
    expert.id,
    ...(alsoRepresents || [])
      .filter((entity) => entity.promotedEntityType === "Id::PromoEntity::Expert")
      .map((entity) => entity.promotedEntityId),
  ];

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} />
        <div className="row g-2">
          <AddExpertInput
            existingExpertsIds={excludedExpertIds}
            onSubmit={async (expertId) => {
              // Stay open on failure so the alert above is what the viewer sees, not a vanished modal.
              const { saved } = await addRepresentation(expertId);
              if (saved) {
                setActiveTabRequest("experts");
                close();
              }
            }}
            onCancel={close}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default ExpertsModalBody;
